const initialState = [];

const ReservationAssignToReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationLogs":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationAssignToReducer;
